import { useState } from "react"

//Assessments components
import AddAssessment from "../AssessmentBlock/AddAssessment"

//Formik
import { useField } from "formik"

//PrimeReact
import { Button } from "primereact/button"

//styling
import assessStyles from "../../../styles/assessments/Assessment.module.css"
import myStyles from "../../../styles/assessments/AssessmentScheduleForm.module.css"
import { InputSwitch } from "primereact/inputswitch"
import { DataTable } from "primereact/datatable"
import { Column } from "primereact/column"

export default function AssessmentSelector({ fieldName, assessments }) {
  const [field, fieldMeta, fieldHelper] = useField(fieldName)

  const [showList, setShowList] = useState(false)

  const availableAssessments = assessments
    ? assessments?.filter(
        (assessment) =>
          !field.value?.some(
            (selected) => selected.assessmentId === assessment.id
          )
      )
    : []

  const addAssessments = (newAssessments) => {
    let newValue = newAssessments.map((newEntry) => {
      return {
        assessmentId: newEntry.assessment_id,
        name: newEntry.assessment_name,
        isRequired: false,
      }
    })

    if (field.value) {
      newValue = [...field.value, ...newValue]
    }

    fieldHelper.setValue(newValue)
    setShowList(false)
  }

  const RequiredBodyTemplate = (rowData) => {
    return (
      <div className={assessStyles.switchControl}>
        <InputSwitch
          checked={rowData.isRequired}
          onChange={(e) => {
            const index = field.value.indexOf(rowData)
            const updatedEntry = { ...rowData, isRequired: e.value }

            const newValues = [...field.value]
            newValues[index] = updatedEntry

            fieldHelper.setValue(newValues)
          }}
        />
      </div>
    )
  }

  const ActionBodyTemplate = (rowData) => {
    return (
      <Button
        type="button"
        onClick={() => {
          fieldHelper.setValue(field.value.filter((entry) => entry !== rowData))
        }}
        className={assessStyles.actionButtonPurple}
        tooltip="Delete schedule"
        tooltipOptions={{ position: "bottom" }}
      >
        <span className={`material-icons`}>{"delete"}</span>
      </Button>
    )
  }

  return (
    <>
      {showList ? (
        <AddAssessment
          availableAssessments={availableAssessments}
          onAdd={addAssessments}
          onClose={() => {
            setShowList(false)
          }}
        />
      ) : null}

      <div className={myStyles.layoutSelector}>
        <div className={myStyles.layoutSelectorHeader}>
          <label>Assessment</label>
          <div style={{ marginBottom: "10px" }}>
            <small style={{ color: "gray" }}>
              Select one or more assessments to be scheduled
            </small>
          </div>
          {fieldMeta.touched && fieldMeta.error ? (
            <label
              id={`${fieldName}-error`}
              className={myStyles.selectorErrorMessage}
            >
              {fieldMeta.error}
            </label>
          ) : null}
        </div>
        <div className={myStyles.layoutSelectorAction}>
          <Button
            type="button"
            onClick={() => {
              setShowList(true)
            }}
            className={assessStyles.actionButtonPurple}
            tooltip="Add assessment"
            tooltipOptions={{ position: "bottom" }}
          >
            <span className={`material-icons`}>{"add"}</span>
          </Button>
        </div>
        <div className={myStyles.layoutSelectorSelected}>
          <DataTable
            value={field.value || []}
            className={`${assessStyles.dataTable}`}
            emptyMessage={"No assessments selected"}
          >
            <Column header={"Name"} field="name" />
            <Column
              header={"Required"}
              body={RequiredBodyTemplate}
              style={{ width: "100px" }}
            />
            <Column body={ActionBodyTemplate} style={{ width: "80px" }} />
          </DataTable>
        </div>
      </div>
    </>
  )
}
